const getters = {
  sidebar: state => state.app.sidebar,
  version: state => state.app.version,
  profile: state => state.app.profile,
  platforms: state => state.app.platforms,
  articlesDataFeature: state => state.app.articlesDataFeature,
  leafletScrapperFeature: state => state.app.leafletScrapperFeature,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  notificationChannels: state => state.user.notificationChannels,
  setting: state => state.user.setting,
  // stores getters
  shops: state => state.shops.shopList,
  openedStores: state => state.shops.openedStores,
  leafletsToActivation: state => state.shops.leafletsToActivation,
  leafletsToDisactivation: state => state.shops.leafletsToDisactivation,
  shopsDataLoading: state => ({
    shopsLoading: state.shops.dataLoading,
    leafletsLoading: state.shops.leafletLoader
  }),
  previousState: state => ({
    hasPreviousState: state.shops.hasPreviousState,
    popstate: state.shops.popstate
  }),
  // leafletDetails getters
  leafletsDescription: state => state.leafletDetails.redirectsDescription,
  // leafletsOrder getters
  leafletsToDisplay: state => state.leafletsOrder.leafletsToDisplay,
  activePlatform: state => state.leafletsOrder.activePlatform,
  allLeaflets: state => state.leafletsOrder.allLeaflets,
  allLeafletsLoadingData: state => state.leafletsOrder.isLoading
}
export default getters
